import React from "react";
import { connect } from "react-redux";
import { cargarFamiliares, cargarPolizas } from "./flujo.act";

import Invitados from "./invitados.cmpt";
import ModalInvitar from "./modalInvitar.cmpt";
import ModalGestionar from "./modalGestionar.cmpt";

const mapState = (state) => {
	return {
		listaFamiliares: state.af.listaFamiliares,
		listaPolizas: state.af.listaPolizas
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargarFamiliares: () => {
			dispatch(cargarFamiliares());
		},
		cargarPolizas: () => {
			dispatch(cargarPolizas());
		}
	};
};

class Datos extends React.Component {
	state = {}

	componentWillMount = () => {
		/*if(this.props.listaFamiliares.length == 0) {
			this.props.cargarFamiliares();
		}
		if(this.props.listaPolizas.length == 0) {
			this.props.cargarPolizas();
		}*/
	}
	
	render() {
		return (
			<div className="container">
				<div className="box-wrap acceso-compartido-container">
					<div className="header-content clearfix mt-50">
						<div className="pull-left">
							<h4>Acceso Compartido</h4>
							<h6><small>Invitados</small></h6>
						</div>
					</div>
					<Invitados />
				</div>
				<div className="modal fade modal-msj" id="modal-invitar" tabIndex="-1" role="dialog" aria-labelledby="modal-invitarLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<ModalInvitar />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-gestionar" tabIndex="-1" role="dialog" aria-labelledby="modal-gestionarLabel">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<ModalGestionar />
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Datos);


// WEBPACK FOOTER //
// ./src/acceso-familiar/flujo.cmpt.js